// extracted by mini-css-extract-plugin
module.exports = {"content":"content___3_sOP","title":"title___LNfgk","featuredAuthor":"featuredAuthor___3ulnS","dek":"dek___1qedO","imageCredit":"imageCredit___sjrkY"};